import {
  WSElementColorsType,
  WSElementProps
} from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import React from "react";
import {
  PayablesFilters,
  usePayablesQuery
} from "../NewPayablesTable/PayablesTable";
import { Summary } from "../Summary/Summary";
import { useDefaultCurrency } from "../../../shared/hooks/useDefaultCurrency";

type Props = WSElementProps & {
  filter: PayablesFilters;
  label: string;
  displayAmount?: boolean;
  color?: WSElementColorsType;
};

export const PayablesSummary: React.FC<Props> = ({
  filter,
  label,
  displayAmount,
  color = "gray200",
  ...elementProps
}) => {
  const payablesQuery = usePayablesQuery(filter, {
    retry: false
  });
  const defaultCurrency = useDefaultCurrency();

  return (
    <Summary
      {...elementProps}
      value={
        payablesQuery.data
          ? displayAmount
            ? formatMoney(
                payablesQuery.data?.summary.totalValue,
                defaultCurrency
              )
            : String(payablesQuery.data?.summary.listSize)
          : "–"
      }
      label={label}
      color={color}
    />
  );
};
